import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-row w-full justify-between" }
const _hoisted_2 = { class: "px-8 mt-2" }
const _hoisted_3 = { class: "flex flex-col space-y-3" }
const _hoisted_4 = { class: "font-sm capitalize" }
const _hoisted_5 = {
  key: 0,
  class: "flex flex-row gap-3 items-center"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "space-x-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", null, _toDisplayString(_ctx.material?.name), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("labels.generic", {
              pt: `Nome do capítulo: ${_ctx.material?.info.chapter}`,
              en: `Chapter name: ${_ctx.material?.info.chapter}`,
            })), 1),
        (_ctx.typeModalHeader == 'STATS_LEARNING_MAP')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("labels.generic", {
                pt: `Feedback do material:`,
                en: `Material feedback:`,
              })), 1),
              _createElementVNode("p", {
                class: _normalizeClass(`${_ctx.materialTag.class} `)
              }, _toDisplayString(_ctx.materialTag.name), 3),
              (_ctx.material?.info.skipped)
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.$t("labels.generic", {
                pt: `| Avançou em: ${_ctx.material?.info.stoppedAt}`,
                en: `| Advanced at: ${_ctx.material?.info.stoppedAt}`,
              })), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_Button, {
        class: "btn-primary",
        icon: "pi pi-chevron-left",
        disabled: _ctx.indexMaterial == 0,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onChooseMaterial(-1)))
      }, null, 8, ["disabled"]),
      _createVNode(_component_Button, {
        class: "btn-primary",
        icon: "pi pi-chevron-right",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onChooseMaterial(1))),
        disabled: _ctx.indexMaterial == _ctx.maxIndexMaterial
      }, null, 8, ["disabled"])
    ])
  ]))
}